import React,{Component} from 'react';


class Login extends Component {
    constructor(props) {
        super(props);
        this.state ={isReady: false};
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        const x = document.getElementById("LoginForm");
        const u = x.elements[0].value;
        const p = x.elements[1].value;
        this.setState({[name]: value})

        if(u.length > 1 && u.length < 32 && p.length > 1 && p.length < 32) {
            this.setState({isReady: true});
        } else {
            this.setState({isReady: false});
        }
        if(this.state.ErrMsg) {
            this.setState({ErrMsg: false});
        }
        
    }
    
    handleSubmit(event) {
        if(this.state.isReady) {
        } else {
            event.preventDefault();
            this.setState({ErrMsg: 'Please provide required login information'});
        }
    }

    componentDidMount() {
        require('./css/Login.css');
    };
    LoginCheck() {

    }

    render(){
        
        return(
            <div className={"Login_Container_"+this.props.Page}>
                <form name="LoginForm" onSubmit={this.handleSubmit} action={this.props.URL} method="post" id="LoginForm">
                    <table className="LoginTable">
                        <tbody>
                                    {this.props.Topic &&
                            <tr >
                                <th colSpan="4">
                                    <h2>Already a {this.props.Topic}?</h2>
                                </th>
                            </tr>
                                }

                            <tr>
                                {this.props.Description &&
                                <td rowSpan="2" width="350px">
                                    <p>{this.props.Description}</p>
                                </td>
                                }
                                <td>{this.props.ID}:</td>
                                <td><input required name={this.props.ID_Key} id={this.props.ID_Key} type="text" onChange={this.handleChange} autoComplete="username"></input></td>
                            </tr>
                            <tr>
                                <td>{this.props.Key}:</td>
                                <td><input required name={this.props.Key_Key} id={this.props.Key_Key} type="password" onChange={this.handleChange} autoComplete="current-password"></input></td>
                                <td><input name="doLogin" className="login_button" type="submit" value=" Login "></input></td>
                            </tr>
                        </tbody>
                    </table>
                    {this.state.ErrMsg && 
                    <p>{this.state.ErrMsg}</p>}
                </form>
            </div>
        )
    }
}



export default Login;
